module.exports = __webpack_public_path__ + "img/delete_blue_line.fac32012.svg";